import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// This class should be used on scenarios where VC can not be calculate
// such as: SSR environment and legacy browsers
export var VCObserverNOOP = /*#__PURE__*/function () {
  function VCObserverNOOP() {
    _classCallCheck(this, VCObserverNOOP);
  }
  return _createClass(VCObserverNOOP, [{
    key: "start",
    value: function start(startArg) {}
  }, {
    key: "stop",
    value: function stop() {}
  }, {
    key: "getVCRawData",
    value: function getVCRawData() {
      return null;
    }
  }, {
    key: "getVCResult",
    value: function getVCResult(param) {
      return Promise.resolve({
        'ufo:vc:noop': true
      });
    }
  }, {
    key: "setSSRElement",
    value: function setSSRElement(element) {}
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart(startTime) {}
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop(stopTime) {}
  }]);
}();